<!-- <nav class="navbar navbar navbar-expand-md navbar-dark">
  <div class="container-fluid mainScheduleContainer">
    <div class="navbar-brand" [routerLink]="['/dashboard']">
      <span class="header-niit-logo" title="NIIT"><img src="assets/logo.svg" alt="NIIT"></span>
      <span class="tr-logo"><span class="talent">Talent</span><span class="readiness">Readiness</span></span>
    </div>
    <button class="navbar-toggler" type="button" data-backdrop="static" data-keyboard="false" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item">
          <div class="headerIcons icon_1" title="Dashboard" [routerLink]="['/dashboard']">
          </div>
        </li>
        <li class="nav-item" *ngIf="superUserType !='super' && superUserType !='admin'">
          <div class="headerIcons icon_2" title="Booking" (click)="gotoNextPage($event, '/planSchedule')">
          </div>
        </li>
        <li class="nav-item" *ngIf="superUserType !='super' && superUserType !='admin'">
          <div class="dropdown viewReportDropDown">
            <div class="customVerticalAlignment headerIcons icon_3" title="View Report" id="dropdownMenuButton"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            </div>
            <div class="dropdown-menu dropdownMenuButton" aria-labelledby="dropdownMenuButton"
              style="left: -39px !important;">
              <a class="dropdown-item " (click)="gotoNextPage($event, '/workload')">Work Load</a>
              <a class="dropdown-item" (click)="gotoNextPage($event, '/resourceBookingReport')">Resource View</a>
              <a class="dropdown-item" (click)="gotoNextPage($event, '/proReport')">Project View</a>
            </div>
          </div>
        </li>
        <li class="nav-item" *ngIf="superUserType !='super' && superUserType !='admin'">
          <div class="headerIcons icon_4 disabled" title="Add User">
          </div>
        </li>
        <li class="nav-item">
            <div title="Add User" class="header-user-details">
                {{loginUserName}}<br />
                {{userType}}
            </div>
        </li>
        <li class="nav-item">
          <a _ngcontent-c2="" title="User Profile" class="ff1" id="dropdownMenuProfileButton" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <img [src]="loginImageURL" class="profileIcon" />
            <span class="caret"></span>
          </a>
          <div class="dropdown-menu" id="dropDownPro" aria-labelledby="dropdownMenuProfileButton">
            <a class="dropdown-item cursorLink">Signed in as
              <br />
              <span>{{loginUserName}}</span>
            </a>
            <hr />
            <a class="dropdown-item" (click)="logout()">Sign out</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav> -->
<headerCustom></headerCustom>

<sidebarWrapper></sidebarWrapper>

<div class="main-content">
    <div class="userDashContainer">
        <div class="pageContentWrapper">
          <div class="">
            <div class="pageHeading">
              <div class="row">
                <div class="col-12">
                  <div class="headerName">
                    <h3>Dashboard</h3>
                    <app-breadcrumb></app-breadcrumb>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row userDropDownContainer">
              <label class="col-md-12">Select User</label>
              <div class="col-md-3">
                <div class="scoreCompStyle" id="adduserPopContainer" *ngIf="userList && userList.length >0">
                  <div class="cusPad">
                    <select class="form-control" [(ngModel)]="selectedCombinedId" placeholder="Select User" (ngModelChange)="loadDashboard()">
                      <option value="Select User">Select User</option>
                      <ng-container *ngFor="let user of userList; let i = index;">
                        <option value="{{user.userId}}_{{user.nextPosition}}_{{user.towerId}}">{{user.userName}}</option>
                      </ng-container>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                  <div [hidden]="!showDashboardSections" class="aggregate_score">Aggregate Score: 
                    <strong >{{ checkIsNumber(compositePercentAverage.full) }}</strong> (30:70)</div>
              </div>
              <div class="col-md-3 addUserButton text-right">
                <button type="button" class="btn hvr-bounce-to-top mr10" (click)="excelDownload()" *ngIf="userBehSkillRatingList.length > 0 && userFunSkillRatingList.length > 0">Download Report</button>
              </div>
            </div>
      
      
      
            <div class="row mt-4" [hidden]="!showDashboardSections">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="swot-analysis">
                      
                      <section>
                        <!-- <header class="swot-heading">SWOT Analysis</header> -->
                        <div id="acdm">
                          <div id="acdm1" class="acdm_child">
                            <div class="acdm_titleP"> Current Role </div>
                            <div class="acdm_footer"> {{ selectedUserPosition }} </div>
                            <!-- <div class="acdm_footer">{{ nextPosition }}</div> -->
                          </div>
                          <div id="acdm2" class="acdm_child" [ngClass]="{'highlighted' : compositePercentAverage.full>=80}" >
                            <div class="acdm_title">0-12 months</div>
                            <div class="acdm_footer">Ready Now</div>
                          </div>
                          <div id="acdm3" class="acdm_child" [ngClass]="{'highlighted' : compositePercentAverage.full<80 && compositePercentAverage.full>=60}">
                            <div class="acdm_title">12 to 18 months</div>
                            <div class="acdm_footer">Ready Soon</div>
                          </div>
                          <div id="acdm4" class="acdm_child" [ngClass]="{'highlighted' : compositePercentAverage.full<60 && compositePercentAverage.full>=30}">
                            <div class="acdm_title">More than 2 years</div>
                            <div class="acdm_footer">Ready Future</div>
                          </div>
                          <div id="acdm5" class="acdm_child">
                            <!-- <div class="acdm_title"> {{ selectedUserPosition }} </div> -->
                            <div class="acdm_titleP">Next Role</div>
                            <div class="acdm_footer">{{ getPositionName(nextPositionId) }}</div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
                <p class="small_note"> These are only indicative timeframes for readiness for target role. The exact timeframe for role change will be determined in consultation with the supervisor and HR.</p>
      
                <ul class="nav nav-tabs mt-80" id="skill_type_selector">
                  <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': activeTab==='beh'}" (click)="generateDashboardData('beh'); activeTab = 'beh'">Behavioral Competencies</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': activeTab==='fun'}" (click)="generateDashboardData('fun'); activeTab = 'fun'">Functional Competencies</a>
                  </li>
                </ul>

                <div class="swot-heading-pos">
                  <header class="swot-heading" *ngIf="activeTab==='beh'">Score: <strong>{{ checkIsNumber(this.compositePercentAverage.beh) }}</strong></header>
                  <header class="swot-heading" *ngIf="activeTab==='fun'">Score: <strong>{{ checkIsNumber(this.compositePercentAverage.fun) }}</strong></header>
                </div>
      
                <div class="row mtb35 user-dash">
                  <div class="col-6">
                    
                    <section>
                      <header class="swot-heading">Competency Analysis</header>
                    </section>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <div class="col-md-12 card">
                          <div class="card-header sbg1">Strengths</div>
                          <div class="card-body">
                            <!-- <h5 class="card-title">Primary card title</h5> -->
                              <ul class="skill-list">
                                <ng-container *ngFor="let skillName of userStrengths;">
                                  <li>{{skillName}}</li>
                                </ng-container>
      
                                <ng-container *ngIf="userStrengths.length === 0">
                                  <p>No competencies under this category</p>
                                </ng-container>
            
                              </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="col-md-12 card">
                          <div class="card-header sbg2">Improvement Area</div>
                          <div class="card-body">
                            <!-- <h5 class="card-title">Primary card title</h5> -->
                            <ul class="skill-list">
                              <ng-container *ngFor="let skillName of userWeaknesses;">
                                <li>{{skillName}}</li>
                              </ng-container>
      
                              <ng-container *ngIf="userWeaknesses.length === 0">
                                <p>No competencies under this category</p>
                              </ng-container>
      
                            </ul>
      
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="col-md-12 card">
                          <div class="card-header sbg3">Opportunities</div>
                          <div class="card-body">
                            <!-- <h5 class="card-title">Primary card title</h5> -->
                            <ul class="skill-list">
                              <ng-container *ngFor="let skillName of userOppurtunities;">
                                <li>{{skillName}}</li>
                              </ng-container>
      
                              <ng-container *ngIf="userOppurtunities.length === 0">
                                <p>No competencies under this category</p>
                              </ng-container>
      
                            </ul>
      
                          </div>
                        </div>
                      </div>
      
                      <div class="col-md-6">
                        <div class="col-md-12 card">
                          <div class="card-header sbg4">Major Improvement Area</div>
                          <div class="card-body">
                            <!-- <h5 class="card-title">Primary card title</h5> -->
                            <ul class="skill-list">
                              <ng-container *ngFor="let skillName of userThreats;">
                                <li>{{skillName}}</li>
                              </ng-container>
      
                              <ng-container *ngIf="userThreats.length === 0">
                                <p>No competencies under this category</p>
                              </ng-container>
      
                            </ul>
      
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                      <section>
                        <header class="swot-heading text-center">Competency Development</header>
                      </section>
                      <div class="cc_Scroll">
                        <div class="canvas_container" [ngStyle]="{ height: canvasContainerHeight }">
                          <canvas id="skill_development_chart" >{{ chart }}</canvas>
                        </div>
                      </div>
      
                    </div>
                </div>
      
              </div>
              <div class="col-4" style="display: none;">
                <div class="row">
                  <div class="col-12">
                    <section>
                      <header>Career path</header>
                    </section>
                    <div class="row">
                      <div class="col-md-6">
                        Content Lead
                      </div>
                      <div class="col-md-6">
                        ACDM
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        Ready Now
                      </div>
                      <div class="col-md-6">
                        0-12 mnths
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        Ready Soon
                      </div>
                      <div class="col-md-6">
                        12-18 mnths
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        Ready Future
                      </div>
                      <div class="col-md-6">
                        More than 2 years
                      </div>
                    </div>
                  </div>
                </div>
      
                <div class="row">
                  <div class="col-12">
                    <section>
                      <header>SWOT Analysis</header>
                    </section>
                  </div>
                </div>
      
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="bottomSeprationWrapper">
            <div class="bottomSepration">
                <div class="triangleShape">
                    <i class="fa fa-sort-up"></i>
                </div>
                <p>Select a user from above to see hisher dashboard</p>
            </div>
        </div> -->

        <div class="stepSectionWrapper" *ngIf="selectedUserId == 'Select User'">
          <div class="stepSection">
            <div class="starTop">
              <!-- <div class="fullWidth">
                  <div class="circleWrapper"> <div><i class="fa fa-user"></i></div> <span>User</span> </div>
              </div> -->
              <div class="circleWrapper"> <div><i class="fa fa-user"></i></div> <span>User</span> </div>
              <div class="circleWrapper"> <div><i class="fa fa-user-cog"></i></div> <span>Behavior/ Function Skill</span> </div>
              <div class="circleWrapper"> <div><i class="fa fa-star"></i></div> <span>Aggregate Score</span> </div>
            </div>
            <div class="step-1">
              <p>Select a user from above drop down.</p>
            </div>
            <!-- <div class="step-2">
              <p><strong class="highlight">Step 2</strong> Then select desired skill are from above right side options.</p>
            </div> -->
          </div>
        </div>

      </div>
</div>


